import { render } from "./JsonTreeViewItem.vue?vue&type=template&id=d1960c30&ts=true"
import script from "./JsonTreeViewItem.vue?vue&type=script&lang=ts"
export * from "./JsonTreeViewItem.vue?vue&type=script&lang=ts"

import "./JsonTreeViewItem.vue?vue&type=style&index=0&id=d1960c30&lang=scss"

import exportComponent from "/home/ubuntu/workspace/OneTegProdDeployment/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__